import { withdrawalHeartbeat } from "./withdrawal-heartbeat";

withdrawalHeartbeat.install(
  () =>
    new Worker(new URL("./heartbeat.worker", import.meta.url), {
      type: "module",
    })
);
